@file:OptIn(InternalResourceApi::class)

package finglish.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/finglish.composeapp.generated.resources/"

@delegate:ResourceContentHash(413_895_366)
internal val Res.drawable.ic_brightness_medium: DrawableResource by lazy {
      DrawableResource("drawable:ic_brightness_medium", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_brightness_medium.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-184_782_238)
internal val Res.drawable.ic_clear: DrawableResource by lazy {
      DrawableResource("drawable:ic_clear", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_clear.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-598_904_097)
internal val Res.drawable.ic_copy: DrawableResource by lazy {
      DrawableResource("drawable:ic_copy", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_copy.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(392_254_604)
internal val Res.drawable.ic_dark_mode: DrawableResource by lazy {
      DrawableResource("drawable:ic_dark_mode", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_dark_mode.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_005_564_041)
internal val Res.drawable.ic_dark_mode_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_dark_mode_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_dark_mode_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_968_555_747)
internal val Res.drawable.ic_light_mode: DrawableResource by lazy {
      DrawableResource("drawable:ic_light_mode", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_light_mode.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_234_884_499)
internal val Res.drawable.ic_light_mode_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_light_mode_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_light_mode_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_688_849_109)
internal val Res.drawable.ic_more_vert: DrawableResource by lazy {
      DrawableResource("drawable:ic_more_vert", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_more_vert.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-257_925_144)
internal val Res.drawable.ic_paste: DrawableResource by lazy {
      DrawableResource("drawable:ic_paste", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_paste.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_079_952_306)
internal val Res.drawable.ic_settings: DrawableResource by lazy {
      DrawableResource("drawable:ic_settings", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_settings.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_385_026_912)
internal val Res.drawable.ic_share: DrawableResource by lazy {
      DrawableResource("drawable:ic_share", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_share.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(574_365_616)
internal val Res.drawable.ic_sun: DrawableResource by lazy {
      DrawableResource("drawable:ic_sun", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_sun.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-94_231_341)
internal val Res.drawable.ic_sun_filled: DrawableResource by lazy {
      DrawableResource("drawable:ic_sun_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_sun_filled.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_brightness_medium", Res.drawable.ic_brightness_medium)
  map.put("ic_clear", Res.drawable.ic_clear)
  map.put("ic_copy", Res.drawable.ic_copy)
  map.put("ic_dark_mode", Res.drawable.ic_dark_mode)
  map.put("ic_dark_mode_filled", Res.drawable.ic_dark_mode_filled)
  map.put("ic_light_mode", Res.drawable.ic_light_mode)
  map.put("ic_light_mode_filled", Res.drawable.ic_light_mode_filled)
  map.put("ic_more_vert", Res.drawable.ic_more_vert)
  map.put("ic_paste", Res.drawable.ic_paste)
  map.put("ic_settings", Res.drawable.ic_settings)
  map.put("ic_share", Res.drawable.ic_share)
  map.put("ic_sun", Res.drawable.ic_sun)
  map.put("ic_sun_filled", Res.drawable.ic_sun_filled)
}
